import { render, staticRenderFns } from "./Drawer24.vue?vue&type=template&id=5d232b60"
import script from "./Drawer24.vue?vue&type=script&lang=js"
export * from "./Drawer24.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports